import React, {Component} from "react";
import {Card} from "antd";
import Spinner from "react-spinkit";
import {compose} from "redux";
import {connect} from "react-redux";
import ListForm from "./ListForm";
import {updateContactListDetails} from "../../../actions/contactlists";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {currentEffectiveUserId} from "../../../reducers/ui";

export class ListEdit extends Component {
  render() {
    const { list, onSubmit, onCancel } = this.props;
    return <Card
      title={<h1 className={'nomargins'}>Contact List Details</h1>}
      className={'edit-view'}
    >
      {!list ? <Spinner/> : <ListForm list={list} onCancel={onCancel} onSubmit={onSubmit()}/>}
    </Card>;
  }
}

export default compose(
  connect(
    (state, props) => !currentEffectiveUserId(state) ? { loading: true } : {
      list: state.view.data[props.match.params.listId],
    },
    (dispatch, props) => ({
      onSubmit: () => list => {
        dispatch(updateContactListDetails(list.id, list.name, list.description));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(ListEdit);



// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ListEdit.js